import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl/dist';
import Sidebar from './Sidebar';
import { configs } from '../../../constants/configs/configs';
import { BREAK_POINTS } from '../../../constants/common/breakpoints';

interface LayoutProps {
    children: React.ReactNode | JSX.Element;
}

const StyledContainer = styled.div`
    max-width: 1240px;
    background-color: ${({ theme }) => theme.gray11};
    margin: auto;
    display: flex;
    margin-top: 20px;
    padding: 0px 20px;
    min-height: calc(100vh - 420px);
    @media (max-width: ${BREAK_POINTS.sm}) {
        display: block;
        margin-top: 0;
    }
`;

const StyledRightPanel = styled.div`
    width: 75%;
    margin-left: 25px;

    @media (max-width: ${BREAK_POINTS.sm}) {
        width: 100%;
        margin-left: 0;
        margin-top: 20px;
    }
`;

const StyledIconContainer = styled.div`
    display: flex;
    margin: auto;
    margin-bottom: 20px;
    margin-top: 20px;
    max-width: 1240px;
    align-items: center;
    color: ${({ theme }) => theme.primaryMain};
    padding: 0px 20px;

    &:hover {
        color: ${({ theme }) => theme.primaryDark};
    }
    @media (max-width: ${BREAK_POINTS.sm}) {
        width: 100%;
    }
`;

const StyledIconLabel = styled.div`
    margin-left: 6px;
    margin-top: 2px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
`;

export const StyledIdentityHeader = styled.h4<{ fontWeight?: number }>`
    background-color: ${({ theme }) => theme.gray9};
    font-size: 16px;
    color: ${({ theme }) => theme.gray2};
    font-weight: ${({ fontWeight }) => fontWeight || 600}; // Default to 600 if no prop is passed
    margin: 0;
    border-left: none;
    border-right: none;
    padding: 16px;
`;

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const {
        routes: { SSAP },
    } = configs;

    const backToApplication = () => {
        const queryParams = new URLSearchParams(window.location.search);
        const coverageYear = queryParams.get('coverageYear');
        const applicationType = queryParams.get('applicationType');
        if (coverageYear && applicationType) {
            window.location.href = `${SSAP}?applicationType=${applicationType}&coverageYear=${coverageYear}`;
        } else {
            window.location.href = `${SSAP}`;
        }
    };
    return (
        <>
            <StyledIconContainer onClick={backToApplication}>
                <FontAwesomeIcon icon={faArrowAltCircleLeft} />
                <StyledIconLabel>
                    <FormattedMessage id="ridp.backToApplication" />
                </StyledIconLabel>
            </StyledIconContainer>
            <StyledContainer>
                <Sidebar />
                <StyledRightPanel>{children}</StyledRightPanel>
            </StyledContainer>
        </>
    );
};

export default Layout;
